const CoordTrans = {
	// 定义常量
	PI: Math.PI,
	a: 6378245.0, // 长半轴
	ee: 0.00669342162296594323, // 偏心率平方

	isChinaArea(lng, lat) {
		return !(lng < 72.004 || lng > 137.8347 || lat < 0.8293 || lat > 55.8271);
	},

	delta(lng, lat) {
		let dLat = this.transformLat(lng - 105.0, lat - 35.0);
		let dLng = this.transformLng(lng - 105.0, lat - 35.0);
		const radLat = lat / 180.0 * this.PI;
		let magic = Math.sin(radLat);
		magic = 1 - this.ee * magic * magic;
		const sqrtMagic = Math.sqrt(magic);
		dLat = (dLat * 180.0) / ((this.a * (1 - this.ee)) / (magic * sqrtMagic) * this.PI);
		dLng = (dLng * 180.0) / (this.a / sqrtMagic * Math.cos(radLat) * this.PI);
		return { dx: dLng, dy: dLat };
	},

	transformLat(x, y) {
		let ret = -100.0 + 2.0 * x + 3.0 * y + 0.2 * y * y + 0.1 * x * y + 0.2 * Math.sqrt(Math.abs(x));
		ret += (20.0 * Math.sin(6.0 * x * this.PI) + 20.0 * Math.sin(2.0 * x * this.PI)) * 2.0 / 3.0;
		ret += (20.0 * Math.sin(y * this.PI) + 40.0 * Math.sin(y / 3.0 * this.PI)) * 2.0 / 3.0;
		ret += (160.0 * Math.sin(y / 12.0 * this.PI) + 320 * Math.sin(y * this.PI / 30.0)) * 2.0 / 3.0;
		return ret;
	},

	transformLng(x, y) {
		let ret = 300.0 + x + 2.0 * y + 0.1 * x * x + 0.1 * x * y + 0.1 * Math.sqrt(Math.abs(x));
		ret += (20.0 * Math.sin(6.0 * x * this.PI) + 20.0 * Math.sin(2.0 * x * this.PI)) * 2.0 / 3.0;
		ret += (20.0 * Math.sin(x * this.PI) + 40.0 * Math.sin(x / 3.0 * this.PI)) * 2.0 / 3.0;
		ret += (150.0 * Math.sin(x / 12.0 * this.PI) + 300.0 * Math.sin(x / 30.0 * this.PI)) * 2.0 / 3.0;
		return ret;
	},

	cgcs2Gcj(lng, lat) {
		lng = parseFloat(lng);
		lat = parseFloat(lat);
		if (!lng || !lat || !this.isChinaArea(lng, lat)) {
			return { lng, lat };
		}
		const { dx, dy } = this.delta(lng, lat);
		return {
			lng: lng + dx,
			lat: lat + dy
		};
	},

	gcj2Cgcs(lng, lat) {
		lng = parseFloat(lng);
		lat = parseFloat(lat);
		if (!lng || !lat || !this.isChinaArea(lng, lat)) {
			return { lng, lat };
		}
		const { dx, dy } = this.delta(lng, lat);
		return {
			lng: lng - dx,
			lat: lat - dy
		};
	}
};

export default CoordTrans;